import { render, staticRenderFns } from "./addInductor.vue?vue&type=template&id=2fd82e68&scoped=true"
import script from "./addInductor.vue?vue&type=script&lang=js"
export * from "./addInductor.vue?vue&type=script&lang=js"
import style0 from "./addInductor.vue?vue&type=style&index=0&id=2fd82e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd82e68",
  null
  
)

export default component.exports